
import React from 'react';
import './PublicGrid.css';

export default function Grid({
  columns = [],
  data = [],
  onRowClick = null
}) {
  return (
    <div className="PublicGrid-container">
      <table className="PublicGrid-table">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col.header}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="PublicGrid-empty">
                Nenhum registro encontrado.
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => onRowClick && onRowClick(row)}
                style={{
                  cursor: onRowClick ? 'pointer' : 'default'
                }}
              >
                {columns.map((col, colIndex) => (
                  <td key={colIndex}>
                    {row[col.field] !== undefined ? row[col.field] : '-'}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
